import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

const GL = (props) => {
    const { gl } = useThree();
    useEffect(() => {
        // gl === WebGLRenderer
        // gl.info.calls
        //console.log(gl.info);
        props.site.gl = gl;
    });
    return null;
};

export default GL;